import EthButton from "../Buttons/AuthButtons/EthButtons/EthButton";
import TonConnectButton from "../Buttons/AuthButtons/TonButtons/TonConnectButton";
import SignInButton from "../Buttons/AuthButtons/Web2Buttons/SignInButton";
import "./style.scss";
import { Modal } from "antd";
import React from "react";

interface IMainMenuProps {
  isOpen: boolean;
  onClose: () => void;
  updateProfile: () => void;
}

export default function MainMenu({
  isOpen,
  onClose,
  updateProfile,
}: IMainMenuProps) {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      className="main-menu"
      wrapClassName="main-menu-wrapper"
      width={414}
      zIndex={999}
      bodyStyle={{ background: "#082148", borderRadius: 32 }}
      style={{ background: "#082148", borderRadius: 32 }}
      footer={null}
    >
      <SignInButton updateProfile={updateProfile} mainModalClose={onClose} />
      <TonConnectButton mainModalClose={onClose} />
      <EthButton mainModalClose={onClose} />
    </Modal>
  );
}
